import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Bell } from 'lucide-react';
import NotificationSettings from '../../components/notifications/NotificationSettings';
import ChannelConfiguration from '../../components/settings/ChannelConfiguration';

const NotificationSettingsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bell className="h-5 w-5" />
            Laboratory Notification Settings
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-md border border-info-200 bg-info-100 p-4 text-sm">
            <p className="font-medium">Laboratory Notification Configuration</p>
            <p className="text-muted-foreground mt-1">
              Configure notification channels, templates, and delivery settings
              for sample processing, results delivery, and appointment reminders.
            </p>
          </div>
          <NotificationSettings />
          <ChannelConfiguration />
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationSettingsPage;
